<template>
  <div>
    <div class="row evollu-form">
      <!--Created At Filter --->
      <div class="col-12 col-md-4">
        <label class="form-label">{{ $t('statistics.daterange_created_at') }}</label>
        <RangeDatePicker
          id="date-filter-picker"
          v-model="filters.date"
          class="col-12 datesFilter"
          :placeholder="$t('optometry.leads.date_range')"/>
      </div>
      <div class="col-12 col-md-4">
        <div>
          <label class="form-label">{{$t('facility.inputs.entity')}}:</label>
          <multiselect
            v-model="filters.entity"
            :options="allowedEntities"
            track-by="id"
            label="name"
            :custom-label="formatedEntityLabel"
            select-label=""
            selected-label=""
            deselect-label=""
            :placeholder="$t('facility.inputs.entity')"
            :allow-empty="true"
            :multiple="false"
            :searchable="true"
            :disabled="entitiesOptions.length === 1 || filters.activity === null">
            <template slot="clear">
                <span class="multiselect__clear" v-if="filters.entity"
                      @mousedown.prevent.stop="clearEntitiesMultiselect"></span>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="col-12 col-md-4">
        <div>
          <label class="form-label">{{$t('agenda.appointments.facility')}}:</label>
          <multiselect
            v-model="filters.facility"
            :options="facilitiesOptions"
            track-by="id"
            label="name"
            :custom-label="formatedEntityLabel"
            select-label=""
            selected-label=""
            deselect-label=""
            :placeholder="$t('agenda.appointments.facility')"
            :allow-empty="true"
            :multiple="false"
            :searchable="true"
            :disabled="facilitiesOptions.length <= 1">
            <template slot="clear">
                <span class="multiselect__clear" v-if="filters.facility"
                      @mousedown.prevent.stop="filters.facility = ''"></span>
            </template>
          </multiselect>
        </div>
      </div>
    </div>

    <v-server-table
      id="peopleManagerList"
      ref="peopleManagerList"
      name="peopleManagerList"
      :columns="columns"
      :options="tableOptions"
      @filter="onFilterUpdate"
      @row-click="redirectToPerson"
      >

        <span slot="createdAt" slot-scope="props">
            {{ props.row.createdAt | localTime('YYYY-MM-DD HH:mm') }}
        </span>
        <span slot="name" slot-scope="props">
              {{ handlePatientName(props.row) }}
        </span>
        <span slot="phone" slot-scope="props">
              {{ props.row.mobilePhone }}
        </span>
      <span slot="gender" slot-scope="props">
              {{ props.row.gender ? $t(`genders.${props.row.gender}`) : "N/A" }}
        </span>
      <span slot="originEntity" slot-scope="props">
              {{ handleOriginEntityName(props.row.originEntityId) }}
        </span>
      <span slot="originFacility" slot-scope="props">
              {{ handleOriginFacilityName(props.row.originEntityId, props.row.originFacilityId)}}
        </span>
    </v-server-table>
  </div>
</template>

<script>
import RangeDatePicker from '@/components/common/RangeDatePicker.vue';
import Multiselect from 'vue-multiselect';
import TableQueryMixin from '@/mixins/TableQueryMixin.vue';
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter.vue';
import { PeopleManagerService } from '@/api/PeopleManagerService';
const PEOPLE_MANAGER_LIST_INFO_TYPE = 110

export default {
  components: { Multiselect, RangeDatePicker },
  mixins: [TableQueryMixin, MultiselectLabelFormatter],
  props: {
    serviceSlug: {
      type: String,
      required: true
    },
    querySearch: {
      type: String,
      required: false,
      default: null
    },
    customQueries: {
      type: Object,
      required: false,
      default: null
    },
  },
  data: function () {
    return {
      entitiesOptions: [],
      facilitiesOptions: [],
      filters: {
        entity: null,
        facility: null,
        querySearch: '',
        date: {
          start: '',
          end: '',
        }
      },
      columns: [
        'createdAt',
        'name',
        'phone',
        'taxNr',
        'gender',
        'birthdate',
        'originEntity',
        'originFacility',
      ],
      queryUrl: `${this.$store.state.people_manager_server}/v1/people/list`,
      tableOptions: {
        saveState: false,
        columnsDropdown: true,
        filterable: true,
        sortable: [],
        customFilters: ['start', 'end', 'entity', 'facility'],
        headings: {
          'createdAt': this.$t('people_manager.table.created_at'),
          'name': this.$t('people_manager.table.name'),
          'email': this.$t('people_manager.table.email'),
          'phone': this.$t('people_manager.table.phone'),
          'taxNr': this.$t('people_manager.table.nif'),
          'gender': this.$t('people_manager.table.gender'),
          'birthdate': this.$t('people_manager.table.birthdate'),
          'originEntity': this.$t('people_manager.table.originEntity'),
          'originFacility': this.$t('people_manager.table.originFacility'),
        },
        columnsClasses: {},
        orderBy: {
          column: 'createdAt',
          ascending: 0
        }
      },
    }
  },
  methods: {
    redirectToPerson: function ({ row }) {
      this.$router.push({ name: `${this.serviceSlug}/people-manager/list/patient/id`, params: { id: row.id } })
    },
    clearEntitiesMultiselect: function () {
      this.filters.entity = null
      this.filters.facility = null

      this.$refs.peopleManagerList.customQueries.facility = ''
      this.emitTableFilter(`vue-tables.peopleManagerList.filter::entity`, '')
    },
    handlePatientName: function (elem) {
      var str = ''
      if(elem.firstName) {
        str += elem.firstName
        if (elem.lastName) {
          str += ' '+elem.lastName
        }
      }
      return str
    },
    handleOriginEntityName: function (entityId) {
      if(!entityId) { return "N/A"}
      const entity = this.allowedEntities.find(entity => entity.id === parseInt(entityId))
      return entity ? entity.name : "N/A"
    },
    handleOriginFacilityName: function (entityId, facilityId) {
      if(!entityId || !facilityId) { return "N/A"}
      const entity = this.allowedEntities.find(entity => entity.id === parseInt(entityId))
      const facility = entity.facilities.find(facility => facility.id === parseInt(facilityId))
      return facility ? facility.name : "N/A"
    },
  },
  computed: {
    peopleManagerService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.people_manager_server) || null
    },
    allowedEntities: function () {
      if (this.peopleManagerService) {
        if(this.peopleManagerService.user_permissions.length > 0) {
          const allowedEntitiesIds = this.peopleManagerService.user_permissions.filter(elem => elem.info_type === PEOPLE_MANAGER_LIST_INFO_TYPE).map(elem => elem.entity_id)
          if(allowedEntitiesIds.some(id => id === null)) {
            const entities = this.peopleManagerService.entities
            if(entities.length && entities.length === 1) {
              this.filters.entity = entities[0]
            }
            return entities
          } else {
            const entities = this.peopleManagerService.entities.filter(entity => allowedEntitiesIds.includes(entity.id))
            if(entities.length && entities.length === 1) {
              this.filters.entity = entities[0]
            }
            return entities
          }
        }
      }
      return []
    },
  },
  watch: {
    querySearch: {
      handler: function (value) {
        if(value.length >= 3) {
          this.filters.querySearch = value || ''
        } else if (value.length < 3 && this.filters.querySearch !== '') {
          this.filters.querySearch = ''
        }
      },
      immediate: true
    },
    'filters.querySearch': function (value) {
      this.$refs['peopleManagerList'].setFilter(value)
    },
    'filters.date': function (value) {
      this.$refs['peopleManagerList'].customQueries.start = value.start || ''
      this.emitTableFilter(`vue-tables.peopleManagerList.filter::end`, value.end || '')
    },
    'filters.entity': function (value) {
      if (value) {
        this.facilitiesOptions = value.facilities
        if(this.facilitiesOptions.length && this.facilitiesOptions.length === 1) {
          this.filters.facility = this.facilitiesOptions[0]
        }
      }
      this.emitTableFilter(`vue-tables.peopleManagerList.filter::entity`, parseInt(value.id) || '')
    },
    'filters.facility': function (value) {
      this.emitTableFilter(`vue-tables.peopleManagerList.filter::facility`, parseInt(value.id) || '')
    }
  },


};
</script>

<style scoped lang="scss">

</style>
